import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalVariableService } from '../../../../services/configuration/global-variable.service';
import { GenericModalService } from '../../../../services/generic-modal.service';
import {CustomValidator} from '../../../../services/custom-validator';
import {MetadataService} from '../../../../services/configuration/metadata.service';
import {DateTimeService} from '../../../../services/date-time.service';

@Component({
  selector: 'app-metadata-structure-modal',
  templateUrl: './metadata-structure-modal.component.html',
  styleUrls: ['./metadata-structure-modal.component.css', '../../../../styles/modals.css']
})
export class MetadataStructureModalComponent implements OnInit, AfterViewInit {

  get formData() { return this.metadataForm.controls; }

  constructor(
    public bsModalRef: BsModalRef,
    private formBuilder: FormBuilder,
    private metadataService: MetadataService,
    private dateTimeService: DateTimeService
  ) { }

  @Input() modalTitle: string;
  itemSaved: Subject<boolean> = new Subject();
  metadataForm: FormGroup;
  objInitialState: any;
  submitted = false;
  submitClick = false;
  errorMessage = '';
  isNew: boolean;
  domainValue;
  errorExistsDomain = false;

  ngOnInit() {
    this.isNew = !this.objInitialState.metadataStructureId;
    this.createForm();
  }

  ngAfterViewInit() {
    if (this.objInitialState.metadataStructureId) {
      this.patchVariableGroupValues();
    }
  }

  createForm() {
    this.metadataForm = this.formBuilder.group({
      metadataStructureId: [0],
      name: [ '', Validators.compose( [
        CustomValidator.trimRequired,
        Validators.maxLength(50),
        Validators.pattern('^[a-zA-Z][a-zA-Z0-9_]*') ])
      ],
      description: ['', [Validators.maxLength(250) ]],
      type: [1, [Validators.required ]],
      editingBy: [0, [Validators.required ]],
      domain: [null],
      category: [ 0, Validators.required]
    });
  }

  patchVariableGroupValues() {
    this.metadataForm.controls.name.disable();
    this.metadataForm.controls.type.disable();
    this.metadataForm.controls.category.disable();

    this.metadataForm.patchValue({
      metadataStructureId: this.objInitialState.metadataStructureId,
      name: this.objInitialState.name,
      description: this.objInitialState.description,
      type: this.objInitialState.type,
      editingBy: this.objInitialState.editingBy,
      domain: this.objInitialState.domain,
      category: this.objInitialState.category
    });
  }

  cleanDomain() {
    this.formData.domain.setValue([]);
  }

  getNumber(sNumber) {
    return Number(sNumber);
  }

  addDomain(domainValue) {
    this.errorExistsDomain = false;
    if (!this.formData.domain.value){
      this.formData.domain.setValue([]);
    } else {
      let exists = this.formData.domain.value.filter(d => d == domainValue);
      if (exists && exists.length > 0){
        this.errorExistsDomain = true;
        return;
      }
    }
    if (this.formData.type.value == 2){
      domainValue = this.dateTimeService.formatBrDateTime(domainValue);
    }
    this.formData.domain.value.push(domainValue);
    this.domainValue = '';
  }

  removeDomain(domainVal) {
    this.errorMessage = '';
    this.formData.domain.value.splice(this.formData.domain.value.indexOf(domainVal), 1);
  }


  cleanErrors() {
    this.errorExistsDomain = false;
  }

  onSave() {
    this.errorMessage = '';
    const obj = this.metadataForm.getRawValue();
    obj.type = this.getNumber(obj.type);
    obj.editingBy = this.getNumber(obj.editingBy);
    obj.category = this.getNumber(obj.category);
    this.createMetadataStructure(obj);
  }

  createMetadataStructure(obj) {
    this.metadataService.saveMetadataStructure(obj)
      .subscribe( () => {
          this.submitted = true;
          this.itemSaved.next(true);
          setTimeout(() => { this.submitted = false; this.bsModalRef.hide(); }, 2000);
        },
        error => {
          let err = error;
          if (error.indexOf('401') !== -1) {
            err = 'Erro: Sessão expirada.';
          }
          this.errorMessage = err;
          this.submitClick = false;
        });
  }


  onClose() {
    this.itemSaved.next(false);
    this.bsModalRef.hide();
  }

  blockUserInput() {
    return false;
  }
}
